module.exports = __webpack_public_path__ + "img/product-xjg-3369.5f4e2c9d.png";